"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CodeSnippet;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _CodeSnippetBlock = _interopRequireDefault(require("./CodeSnippetBlock"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Code snippet](https://docs.vanillaframework.io/base/code#code-snippet).
 *
 * #### Blocks
 *
 * A single `CodeSnippet` component can render multiple separate code blocks. Blocks are provided as an array via the `blocks` prop. Each block object defines values of props for each code block of the snippet.
 */
function CodeSnippet(_ref) {
  let {
    className,
    blocks,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)("p-code-snippet", {
      "is-bordered": blocks.some(block => block.content)
    }, className)
  }, props), blocks.map((blockProps, i) => /*#__PURE__*/_react.default.createElement(_CodeSnippetBlock.default, _extends({
    key: "code-snippet-block-".concat(i)
  }, blockProps))));
}